import React, { useEffect, useState } from 'react';
import {
  FINANCE_V2_HOSTNAME,
  INVOICE_TRACKING_HOSTNAME,
  REPORT_HOSTNAME,
} from '../../../../common-utilities/utils/end-points';
import { HTTP_METHODS, invokeApi } from '../../../utils/http-service';
import { getHeaderConfig } from './helper';
import MuiTable from '../../../../common-utilities/core/mui-table';
import { FINANCE_REST_URLS } from '../../../../common-utilities/utils/end-points/finance-v2';
import { Autocomplete, Button, TextField } from '@mui/material';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import CustomModal from '../../../../common-utilities/core/modal';
import './index.scss';
import { exportToExcel, formatDate } from '../../../../common-utilities/utils';
import { DATE_FORMATS } from '../../../../common-utilities/utils/constants';
// import { isCreateAllowed, isDepartmentUserRole } from '../../../utils/common-utils';
import { isCreateAllowed, isUpdateAllowed, hasDepartmentUserMasterAccess } from '../../../utils/common-utils';
import { toast } from 'react-toastify';
import ConfirmModal from '../../../../common-utilities/core/confirm-modal';
import FileUpload from '../../../../common-utilities/core/file-uploader';
import DownloadTemplateButton from '../common-components/upload-template';
import { uploadTemplates } from '../constants';
import { formatReport } from './utils';
import { setProperty } from '../../../../common-utilities/utils/misc';
import VendorMappingHistory from './history';

const VendorItemMap = ({}) => {
  const [budgetModal, setBudgetModal] = useState(false);
  const [formDetails, setFormDetails] = useState({});
  const [budgetList, setBudgetList] = useState([]);
  // const [items, setItems] = useState([]);
  const [creationItems, setCreationItems] = useState([]);
  const [vendorList, setVendorList] = useState([]);
  const [inputValue, setInputValue] = useState('');
  const [vendorInputValue, setVendorInputValue] = useState('');
  const [filters, setFilters] = useState({
    page: 1,
    limit: 10,
    sortBy: '-createdAt',
  });
  const [deleteDetails, setDeleteDetails] = useState(null);
  const [searchKey, setSearchKey] = useState('');
  const [historyDetails, setHistoryDetails] = useState({});

  useEffect(() => {
    loadData(filters);
    loadItems();
    if (
      isCreateAllowed('master_data') ||
      isUpdateAllowed('master_data') ||
      hasDepartmentUserMasterAccess()
    ) {
      loadCreationOptions();
    }
  }, []);

  const loadData = (filters) => {
    let params = {
      ...filters,
      departmentScoped: true,
    };
    if (searchKey) {
      params.searchKey = searchKey;
    }
    invokeApi(
      HTTP_METHODS.GET,
      `${FINANCE_V2_HOSTNAME}${FINANCE_REST_URLS.VENDOR_ITEM_MAPPING}`,
      null,
      params
    )
      .then((response) => {
        if (response.message) {
        } else {
          if (params?.page > response?.totalPages) {
            setProperty('page', response?.totalPages, setFilters);
          }
          setBudgetList(response || []);
        }
      })
      .catch((err) => {});
  };

  const loadItems = () => {
    // Unscoped item list no longer used: the Item dropdown now uses the department-scoped creationItems.
    // invokeApi(
    //   HTTP_METHODS.GET,
    //   `${FINANCE_V2_HOSTNAME}${FINANCE_REST_URLS.ITEMS}`,
    //   null,
    //   { page: 1, limit: 2500 }
    // )
    //   .then((response) => {
    //     if (response.code) {
    //     } else {
    //       setItems(
    //         (response.results || []).map((c) => {
    //           return { label: c.name, value: c.id, id: c.id, code: c.itemCode };
    //         })
    //       );
    //     }
    //   })
    //   .catch((err) => {});
    invokeApi(
      HTTP_METHODS.GET,
      `${INVOICE_TRACKING_HOSTNAME}${FINANCE_REST_URLS.VENDOR_LIST}`
    )
      .then((response) => {
        if (response.code) {
        } else {
          setVendorList(response || []);
        }
      })
      .catch((err) => {});
  };

  const loadCreationOptions = () => {
    invokeApi(
      HTTP_METHODS.GET,
      `${FINANCE_V2_HOSTNAME}${FINANCE_REST_URLS.VENDOR_ITEM_MAPPING_CREATION_OPTIONS}`
    )
      .then((response) => {
        if (response?.code || response?.message) {
          setCreationItems([]);
        } else {
          setCreationItems(
            (response?.items || []).map((c) => {
              return { label: c.name, value: c.id, id: c.id, code: c.itemCode };
            })
          );
        }
      })
      .catch((err) => {});
  };

  // Backend stores fromDate/toDate as UTC-midnight instants; reading them back with
  // local Date getters (as formatDate does on submit) can shift the calendar day by
  // one for timezones behind UTC. Anchor the prefilled value to local midnight of the
  // same UTC calendar day so the round-trip through formatDate reproduces it exactly.
  const parseDateOnlyUTC = (isoString) => {
    if (!isoString) return null;
    const d = new Date(isoString);
    return new Date(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
  };

  const startOfToday = () => {
    const now = new Date();
    return new Date(now.getFullYear(), now.getMonth(), now.getDate());
  };

  const minValidToDate = () => {
    const today = startOfToday();
    if (formDetails.fromDate && new Date(formDetails.fromDate) > today) {
      return formDetails.fromDate;
    }
    return today;
  };

  const isValidityPeriodValid = () => {
    if (!formDetails.fromDate || !formDetails.toDate) {
      toast.error('From Date and To Date are mandatory', { autoClose: 2000 });
      return false;
    }
    if (new Date(formDetails.toDate) < new Date(formDetails.fromDate)) {
      toast.error('To Date cannot be before From Date', { autoClose: 2000 });
      return false;
    }

    if (new Date(formDetails.toDate) < startOfToday()) {
      toast.error('To Date cannot be in the past', { autoClose: 2000 });
      return false;
    }
    return true;
  };

  const isItemInDepartmentScope = () => {
    const selectedItemId = formDetails.item?.id ?? formDetails.item?._id;
    if (selectedItemId == null || creationItems.some((option) => option.id === selectedItemId)) {
      return true;
    }
    toast.error('Selected item does not belong to your department', { autoClose: 2000 });
    return false;
  };

  const onSave = () => {
    if (!isValidityPeriodValid() || !isItemInDepartmentScope()) {
      return;
    }
    const { item = {}, vendor = {} } = formDetails;

    let payload = {
      vendorCode: vendor?.code,
      name: vendor?.name,
      item: item?.id,
      price: formDetails?.price,
      taxPercentage: formDetails?.taxPercentage,
      itemName: item?.label,
      itemCode: item?.code,
      fromDate: formDetails?.fromDate
        ? formatDate(formDetails.fromDate, DATE_FORMATS['YYYY-MM-DD'])
        : null,
      toDate: formDetails?.toDate
        ? formatDate(formDetails.toDate, DATE_FORMATS['YYYY-MM-DD'])
        : null,
    };
    invokeApi(
      HTTP_METHODS.POST,
      `${FINANCE_V2_HOSTNAME}${FINANCE_REST_URLS.VENDOR_ITEM_MAPPING}`,
      payload
    )
      .then((response) => {
        if (response?.message) {
          toast.error(response.message, { autoClose: 2000 });
          return;
        }
        if (response.code) {
          toast.error('Failed to create');
        } else {
          setBudgetModal(false);
          loadData(filters);
          setFormDetails({});
          setInputValue('');
          setVendorInputValue('');
        }
      })
      .catch((err) => {});
  };

  const onUpdate = () => {
    if (!isValidityPeriodValid() || !isItemInDepartmentScope()) {
      return;
    }
    const { item = {}, vendor = {} } = formDetails;
    let payload = {
      vendorCode: vendor?.code,
      name: vendor?.name,
      item: item?.id,
      price: formDetails?.price,
      taxPercentage: formDetails?.taxPercentage,
      itemName: item?.label||item?.name,
      itemCode: item?.code||item?.itemCode,
      fromDate: formDetails?.fromDate
        ? formatDate(formDetails.fromDate, DATE_FORMATS['YYYY-MM-DD'])
        : null,
      toDate: formDetails?.toDate
        ? formatDate(formDetails.toDate, DATE_FORMATS['YYYY-MM-DD'])
        : null,
    };
    invokeApi(
      HTTP_METHODS.PUT,
      `${FINANCE_V2_HOSTNAME}${FINANCE_REST_URLS.VENDOR_ITEM_MAPPING}/${formDetails.id}`,
      payload
    )
      .then((response) => {
        if (response?.message) {
          toast.error(response.message, { autoClose: 2000 });
          return;
        }
        if (response.code) {
          toast.error('Failed to create');
        } else {
          setBudgetModal(false);
          loadData(filters);
          setFormDetails({});
          setInputValue('');
          setVendorInputValue('');
        }
      })
      .catch((err) => {});
  };

  const editRecord = (data) => {
    const { item = {} } = data;

    const vendor = vendorList.find((item) => item.code === data.vendorCode) || {
      name: data.name,
      code: data.vendorCode,
    };
    data.name = vendor.name;
    setVendorInputValue(getVendorOptionLabel(vendor));

    setBudgetModal(true);
    setFormDetails({
      ...data,
      vendor,
      fromDate: parseDateOnlyUTC(data.fromDate),
      toDate: parseDateOnlyUTC(data.toDate),
    });

    setInputValue(getItemOptionLabel(item));
  };

  // Display-only formatting ("ITM001 - Xyz") for the Item dropdown. Handles both option
  // shapes seen here: the loadItems()-mapped {label, code} shape and the raw item object
  // ({name, itemCode}) seeded from an existing mapping's populated `item` field in editRecord.
  const getItemOptionLabel = (op) => {
    if (!op) return '';
    const code = op.code || op.itemCode;
    const name = op.label || op.name || '';
    return code ? `${code} - ${name}` : name;
  };

  // Display-only formatting ("VEN001 - Xyz") for the Vendor dropdown, mirroring the Item dropdown.
  const getVendorOptionLabel = (op) => {
    if (!op) return '';
    const code = op.code;
    const name = op.name || '';
    return code ? `${code} - ${name}` : name;
  };

  const onInputChange = (event) => {
    setFormDetails({
      ...formDetails,
      [event.target.name]: event.target.value,
    });
  };

  const downloadData = () => {
    invokeApi(
      HTTP_METHODS.GET,
      `${REPORT_HOSTNAME}${FINANCE_REST_URLS.VENDOR_ITEM_MAPPING}`,
      null,
      { page: 1, limit: budgetList.totalResults || 1000, departmentScoped: true }
    )
      .then((response) => {
        if (response.message) {
        } else {
          exportToExcel(formatReport(response.results), 'vendor-item-mapping');
        }
      })
      .catch((err) => {});
  };

  const onDelete = () => {
    invokeApi(
      HTTP_METHODS.DELETE,
      `${FINANCE_V2_HOSTNAME}${FINANCE_REST_URLS.VENDOR_ITEM_MAPPING}/${deleteDetails.id}`
    )
      .then((response) => {
        if (response?.message) {
          toast.error(response.message, { autoClose: 2000 });
          return;
        }
        loadData(filters);
        setDeleteDetails(null);
      })
      .catch((err) => {});
  };

  const viewHistory = (data, filters) => {
    invokeApi(
      HTTP_METHODS.GET,
      `${FINANCE_V2_HOSTNAME}${FINANCE_REST_URLS.VENDOR_MAPPING_HISTORY}/${data.id}`,
      null,
      {
        page: filters?.page || 1,
        limit: 5,
      }
    )
      .then((response) => {
        if (response.message) {
        } else if (response.totalResults === 0) {
          toast.info('No History found');
        } else {
          setHistoryDetails({ ...response, mainData: data });
        }
      })
      .catch((err) => {});
  };

  return (
    <div className="finance-v2-vm-list">
      <div className="vm-header-section">
        <div className="left-container">
          <TextField
            placeholder="Search"
            value={searchKey}
            size="small"
            onChange={(e) => setSearchKey(e.target.value)}
          />
          <Button
            variant="outlined"
            onClick={() =>
              loadData({
                page: 1,
                limit: 10,
              })
            }
          >
            Search
          </Button>
        </div>

        <div className="left-container">
          {/* {(isCreateAllowed('master_data') || isDepartmentUserRole()) && ( */}
          {(isCreateAllowed('master_data') || hasDepartmentUserMasterAccess()) && (
            <>
              <FileUpload
                buttonBackground="#fff"
                buttonColor="#008938"
                mainButtonClass="subway-finance-bulk-upload"
                borderColor="rgba(0, 138, 82, 0.5)"
                uploadText="BULK UPLOAD"
                clsName="finance-v2-master-data-uploader"
                url={`${FINANCE_V2_HOSTNAME}${FINANCE_REST_URLS.UPLOAD_MASTER_DATA}vendor-mapping`}
                callBack={() =>
                  loadData({
                    page: filters.page,
                    limit: 10,
                  })
                }
                formDataKey="file"
              />
              <DownloadTemplateButton
                type={uploadTemplates.vendorItemMapping}
                data={{ items: creationItems }}
              />
            </>
          )}

          <Button variant="outlined" disabled={!budgetList.totalResults} onClick={downloadData}>
            Download
          </Button>
          {/* {(isCreateAllowed('master_data') || isDepartmentUserRole()) && ( */}
          {(isCreateAllowed('master_data') || hasDepartmentUserMasterAccess()) && (
            <Button
              variant="outlined"
              onClick={() => {
                setBudgetModal(true);
              }}
            >
              Create
            </Button>
          )}
        </div>
      </div>
      <MuiTable
        columnsList={getHeaderConfig(editRecord, setDeleteDetails, viewHistory)}
        dataList={budgetList.results || []}
        filters={filters}
        nestedValue={true}
        pageCount={budgetList.totalPages}
        onChange={(page) => {
          setFilters({
            ...filters,
            page,
          });
          loadData({
            ...filters,
            page,
          });
        }}
      />

      {budgetModal && (
        <CustomModal
          title="Vendor Item Map"
          disabledOutsideClick={true}
          onClose={() => {
            setBudgetModal(false);
            setFormDetails({});
            setInputValue('');
            setVendorInputValue('');
          }}
        >
          <div className="finance-v2-create-form">
            <Autocomplete
              options={vendorList}
              renderInput={(params) => (
                <TextField {...params} size="small" label="Vendor" />
              )}
              getOptionLabel={getVendorOptionLabel}
              inputValue={vendorInputValue}
              onInputChange={(event, newInputValue) => {
                if (event) {
                  setVendorInputValue(newInputValue);
                }
              }}
              value={formDetails.vendor || ''}
              onChange={(e, val) => {
                setFormDetails({
                  ...formDetails,
                  vendor: val,
                });
              }}
            />

            <Autocomplete
              options={creationItems}
              renderInput={(params) => (
                <TextField {...params} size="small" label="Item" />
              )}
              getOptionLabel={getItemOptionLabel}
              inputValue={inputValue}
              value={formDetails.item || null}
              onInputChange={(event, newInputValue) => {
                if (event) {
                  setInputValue(newInputValue);
                }
              }}
              onChange={(e, val) => {
                setFormDetails({
                  ...formDetails,
                  item: val,
                });
              }}
            />
            <TextField
              value={formDetails.price}
              name="price"
              type="number"
              onChange={onInputChange}
              size="small"
              label="Item Price"
              fullWidth
            />
            <TextField
              value={formDetails.taxPercentage}
              name="taxPercentage"
              type="number"
              onChange={onInputChange}
              size="small"
              label="Tax Percentage"
              fullWidth
            />
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <DesktopDatePicker
                label="Valid From"
                inputFormat="DD/MM/YYYY"
                value={formDetails.fromDate || null}
                onChange={(date) =>
                  setFormDetails({
                    ...formDetails,
                    fromDate: date,
                  })
                }
                renderInput={(params) => (
                  <TextField {...params} size="small" fullWidth />
                )}
              />
            </LocalizationProvider>
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <DesktopDatePicker
                label="Valid To"
                inputFormat="DD/MM/YYYY"
                value={formDetails.toDate || null}
                minDate={minValidToDate()}
                onChange={(date) =>
                  setFormDetails({
                    ...formDetails,
                    toDate: date,
                  })
                }
                renderInput={(params) => (
                  <TextField {...params} size="small" fullWidth />
                )}
              />
            </LocalizationProvider>

            {formDetails.id ? (
              <Button fullWidth variant="contained" onClick={onUpdate}>
                Update
              </Button>
            ) : (
              <Button fullWidth variant="contained" onClick={onSave}>
                Create
              </Button>
            )}
          </div>
        </CustomModal>
      )}
      {deleteDetails && (
        <ConfirmModal onYes={onDelete} onNo={() => setDeleteDetails(null)} />
      )}
      {historyDetails?.results?.length > 0 && (
        <CustomModal
          title="Vendor Mapping History"
          disabledOutsideClick={true}
          onClose={() => setHistoryDetails({})}
        >
          <VendorMappingHistory history={historyDetails} loadData={viewHistory} />
        </CustomModal>
      )}
    </div>
  );
};

export default VendorItemMap;
